import { ProgramQuestionInterface, SessionFeedbackAnswerInterface } from './SessionFeedback';
import { ShowSubmittedFeedback, showQuestion } from './form/SessionQuestion';
import moment from 'moment';

interface ReviewSessionDetailsProp {
	value: string;
	programQuestion: ProgramQuestionInterface[];
	programAnswer: SessionFeedbackAnswerInterface;
}

export function ReviewSessionDetails({ value, programQuestion, programAnswer }: ReviewSessionDetailsProp) {
	const { programme, sessionWith, sessionType, sessionDate, sessionTime, sessionDuration, sessionService } =
		programAnswer.sessionDetailForm;

	if (value !== '1') {
		return programAnswer.sessionFeedbackForm.submitted
			? ShowSubmittedFeedback(programAnswer)
			: showQuestion(programQuestion, programAnswer);
	}

	const details = [
		['Select programme', programme?.label],
		['Who is the mentor / mentee?', sessionWith?.label],
		['Where did the session take place?', sessionType === 0 ? 'Online' : 'Physical'],
		['When the session happen?', sessionDate ? moment(sessionDate).format('DD/MM/YYYY') : '-'],
		['Mentor services', sessionService?.label],
	];

	return (
		<div className="space-y-6">
			{details.slice(0, 4).map(([label, answer]) => (
				<div key={label}>
					<div className="pb-1 text-base font-medium text-gray-900">{label}</div>
					<div className="text-base font-normal text-gray-900">{answer}</div>
				</div>
			))}
			<div className="grid grid-cols-1 gap-6 md:grid-cols-2 md:gap-4">
				<div>
					<div className="pb-1 text-base font-medium text-gray-900">Session time</div>
					<div className="text-base font-normal text-gray-900">
						{sessionTime ? moment(sessionTime).format('h:mm a') : '-'}
					</div>
				</div>
				<div>
					<div className="pb-1 text-base font-medium text-gray-900">Session duration</div>
					<div className="text-base font-normal text-gray-900">{sessionDuration?.label}</div>
				</div>
			</div>
			<div>
				<div className="pb-1 text-base font-medium text-gray-900">{details[4][0]}</div>
				<div className="text-base font-normal text-gray-900">{details[4][1]}</div>
			</div>
		</div>
	);
}
